import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Fetches the simplified pricing (Products + Service Fee + Shipping) for the current cart.
export function useQuote(items, destination = "Greater Accra", promoCode = "") {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const key = JSON.stringify([items.map((i) => [i.id, i.quantity]), destination, promoCode]);

  useEffect(() => {
    if (!items.length) { setQuote(null); return; }
    let active = true;
    setLoading(true);
    api.post("/quote/fees", { items: items.map((i) => ({ product_id: i.id, variant_id: i.variant_id || "", quantity: i.quantity })), destination, promo_code: promoCode })
      .then((r) => { if (active) setQuote(r.data); })
      .catch(() => { if (active) setQuote(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return { quote, loading };
}
